var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-center items-center h-screen"},[_c('div',[_c('loading'),_c('div',{staticClass:"text-lg max-w-sm px-12"},[_vm._v(" Please contact the Tennis Play team to get access to your facility. ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }